import React, { FC } from 'react'
import 'swiper/css'
import { FreeMode } from 'swiper/modules'
import { useSwiper } from '../../../pages/saving/hooks/useSwiper'
import { TierData } from '../types/tierData'
import BadgeComponent from './BadgeComponent'

interface BadgeSwiperProps {
	tiers: TierData[]
	color: string
	isLoading: boolean
}

const BadgeSwiper: FC<BadgeSwiperProps> = ({ tiers, color, isLoading }) => {
	useSwiper('.swiper', {
		modules: [FreeMode],
		direction: 'horizontal',
		slidesPerView: 'auto',
		spaceBetween: 16,
	})

	const renderSkeletonBadges = () => {
		return Array.from({ length: 5 }).map((_, index) => (
			<div className='swiper-slide' key={`skeleton-${index}`}>
				<div className='bg-gray-300 rounded-full h-36 w-36 flex flex-col gap-1 justify-center items-center animate-pulse'></div>
			</div>
		))
	}

	const renderBadges = () => {
		return tiers.map(tierData => (
			<div className='swiper-slide cursor-grab' key={`${tierData.badge.id}-${tierData.tier.id}`}>
				<BadgeComponent
					badge={tierData.badge}
					userBadge={tierData.userBadge}
					tier={tierData.tier}
					isCompleted={tierData.isCompleted}
					isClickable
				/>
			</div>
		))
	}

	return (
		<div className='swiper relative overflow-hidden'>
			<div
				className='fade-left pointer-events-none absolute -left-4 top-0 bottom-0 w-8 z-50'
				style={{
					background: `linear-gradient(to right, ${color} 0%, ${color} 50%, ${color}00 100%)`,
				}}
			/>

			<div
				className='fade-right pointer-events-none absolute -right-4 top-0 bottom-0 w-8 z-50'
				style={{
					background: `linear-gradient(to left, ${color} 0%, ${color} 50%, ${color}00 100%)`,
				}}
			/>

			<div className='swiper-wrapper'>{isLoading ? renderSkeletonBadges() : renderBadges()}</div>
		</div>
	)
}

export default BadgeSwiper
